import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ImageIcon, EditPencilIcon, TrashIcon } from '../../../model/icons';

// Загрузка/замена изображения задания/шаблона (.sp-imgbox).
export default function ImageUpload({ existingUrl, pendingFile, onFileSelect, onClear }) {
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (!pendingFile) { setPreview(null); return undefined; }
        const url = URL.createObjectURL(pendingFile);
        setPreview(url);
        return () => URL.revokeObjectURL(url);
    }, [pendingFile]);

    const url = preview || existingUrl;

    const pick = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = (e) => { if (e.target.files[0]) onFileSelect(e.target.files[0]); };
        input.click();
    };

    if (url) {
        return (
            <div className="sp-imgbox">
                <img src={url} alt="" />
                <div className="acts">
                    <button type="button" className="rep" onClick={pick} title="Заменить"><EditPencilIcon /></button>
                    <button type="button" className="del" onClick={onClear} title="Удалить"><TrashIcon /></button>
                </div>
            </div>
        );
    }

    return (
        <div className="sp-imgbox" role="button" tabIndex={0} style={{ cursor: 'pointer', flexDirection: 'column', gap: 8 }} onClick={pick} onKeyDown={(e) => { if (e.key === 'Enter') pick(); }}>
            <ImageIcon />
            <span style={{ fontSize: 13, color: 'var(--muted)' }}>Загрузить изображение</span>
        </div>
    );
}

ImageUpload.propTypes = {
    existingUrl: PropTypes.string,
    pendingFile: PropTypes.object,
    onFileSelect: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired
};

ImageUpload.defaultProps = { existingUrl: null, pendingFile: null };
